import { render, staticRenderFns } from "./CandidateItem.vue?vue&type=template&id=c4ec828c&scoped=true"
import script from "./CandidateItem.vue?vue&type=script&lang=js"
export * from "./CandidateItem.vue?vue&type=script&lang=js"
import style0 from "./CandidateItem.vue?vue&type=style&index=0&id=c4ec828c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ec828c",
  null
  
)

export default component.exports